// src/components/atoms/WeatherIcon.js
import React from 'react';

// Allgemeine Wetter-Icons
import { ReactComponent as ThunderIcon } from '../../assets/weatherIcons/thunder.svg';
import { ReactComponent as CloudsIcon } from '../../assets/weatherIcons/clouds.svg';
import { ReactComponent as SnowIcon } from '../../assets/weatherIcons/snow.svg';
import { ReactComponent as SunnyIcon } from '../../assets/weatherIcons/sunny.svg';
import { ReactComponent as RainIcon } from '../../assets/weatherIcons/rain.svg';
import { ReactComponent as FogIcon } from '../../assets/weatherIcons/fog.svg';

// Mondphasen-Icons
import { ReactComponent as FullMoonIcon } from '../../assets/weatherIcons/FullMoonIcon.svg';
import { ReactComponent as WaxingGibbousMoonIcon } from '../../assets/weatherIcons/WaxingGibbousMoonIcon.svg';
import { ReactComponent as WaningGibbousMoonIcon } from '../../assets/weatherIcons/WaningGibbousMoonIcon.svg';
import { ReactComponent as FirstQuarterMoonIcon } from '../../assets/weatherIcons/FirstQuarterMoonIcon.svg';
import { ReactComponent as LastQuarterMoonIcon } from '../../assets/weatherIcons/LastQuarterMoonIcon.svg';
import { ReactComponent as WaxingCrescentMoonIcon } from '../../assets/weatherIcons/WaxingCrescentMoonIcon.svg';
import { ReactComponent as WaningCrescentMoonIcon } from '../../assets/weatherIcons/WaningGibbousMoonIcon.svg';
import { ReactComponent as NewMoonIcon } from '../../assets/weatherIcons/NewMoonIcon.svg';
import { ReactComponent as MoonAndStars } from '../../assets/weatherIcons/moon-night-stars-svgrepo-com.svg';

const WEATHER_ICONS = {
  // Allgemeine Wetter-Icons
  thunder: ThunderIcon,
  clouds: CloudsIcon,
  snow: SnowIcon,
  sunny: SunnyIcon,
  rain: RainIcon,
  fog: FogIcon,
  clear: MoonAndStars,
  // Mondphasen
  fullMoon: FullMoonIcon,
  waxingGibbousMoon: WaxingGibbousMoonIcon,
  waningGibbousMoon: WaningGibbousMoonIcon,
  firstQuarterMoon: FirstQuarterMoonIcon,
  lastQuarterMoon: LastQuarterMoonIcon,
  waxingCrescentMoon: WaxingCrescentMoonIcon,
  waningCrescentMoon: WaningCrescentMoonIcon,
  newMoon: NewMoonIcon,
};

const WeatherIcon = ({ type, className, ...props }) => {
  const IconComponent = WEATHER_ICONS[type];

  if (!IconComponent) {
    console.warn(`Weather icon of type "${type}" not found.`);
    return null;
  }

  return <IconComponent className={className} {...props} />;
};

export default WeatherIcon;

//Nutzung mittels <WeatherIcon type="sunny" />